import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "bg-white shadow-md rounded-lg p-6 mb-6" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "bg-white shadow-md rounded-lg p-6 mb-6" }
const _hoisted_7 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_8 = { class: "min-w-full bg-white" }
const _hoisted_9 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_10 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_11 = { class: "py-2 px-4 border-b border-gray-200" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "bg-white shadow-md rounded-lg p-6 mb-6"
}
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "border rounded p-4 bg-gray-50 h-64 overflow-auto relative" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "mb-4" }
const _hoisted_20 = { class: "mb-4" }
const _hoisted_21 = { class: "mb-4" }
const _hoisted_22 = { class: "flex justify-end space-x-3" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "bg-white shadow-md rounded-lg p-6 mb-6" }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = { class: "flex items-center space-x-4" }
const _hoisted_29 = { class: "inline-flex items-center" }
const _hoisted_30 = { class: "inline-flex items-center" }
const _hoisted_31 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_32 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_36 = { class: "space-y-2" }
const _hoisted_37 = { class: "flex items-center" }
const _hoisted_38 = { class: "text-sm truncate max-w-xs" }
const _hoisted_39 = { class: "text-xs text-gray-500 ml-2" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!
  const _component_EmailPreviewModal = _resolveComponent("EmailPreviewModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[43] || (_cache[43] = _createElementVNode("h2", { class: "text-2xl font-bold mb-2" }, "Email Generator", -1)),
    _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-muted-foreground mb-4" }, "Create and manage automated email communications based on reporting calendars", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "1. Upload Reporting Calendar", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[19] || (_cache[19] = _createElementVNode("label", {
          class: "block text-gray-700 text-sm font-bold mb-2",
          for: "calendar-file"
        }, " Select Excel File ", -1)),
        _createElementVNode("input", {
          type: "file",
          id: "calendar-file",
          accept: ".xlsx, .xls",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
          class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        }, null, 32)
      ]),
      (_ctx.uploadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.uploadError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.parseFile && _ctx.parseFile(...args))),
        disabled: !_ctx.selectedFile,
        class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50"
      }, " Parse Calendar ", 8, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "2. Saved Drafts", -1)),
      (_ctx.savedDrafts.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[21] || (_cache[21] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Subject "),
                  _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Created At "),
                  _createElementVNode("th", { class: "py-2 px-4 border-b border-gray-200 bg-gray-50 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider" }, " Actions ")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedDrafts, (draft) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: draft.id
                  }, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(draft.subject), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.formatDate(draft.createdAt)), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.loadEmailDraft(draft.id)),
                        class: "text-blue-500 hover:text-blue-700 mr-2"
                      }, " Load ", 8, _hoisted_12),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.showDeleteConfirmation(draft.id, draft.subject)),
                        class: "text-red-500 hover:text-red-700"
                      }, " Delete ", 8, _hoisted_13)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_EmptyState, {
            key: 1,
            icon: "document",
            title: "No Saved Drafts",
            message: "You haven't saved any email drafts yet. After creating a draft, click 'Save Draft' to save it here.",
            iconClass: "text-gray-400"
          }))
    ]),
    (_ctx.emailDraft)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "3. Email Draft Preview", -1)),
          _createElementVNode("div", _hoisted_15, [
            _cache[23] || (_cache[23] = _createElementVNode("label", {
              class: "block text-gray-700 text-sm font-bold mb-2",
              for: "email-subject"
            }, " Subject ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "email-subject",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.emailDraft.subject) = $event)),
              class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            }, null, 512), [
              [_vModelText, _ctx.emailDraft.subject]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block text-gray-700 text-sm font-bold mb-2" }, " HTML Content ", -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", { innerHTML: _ctx.processedHtmlContent }, null, 8, _hoisted_18),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPreviewModal = true)),
                class: "absolute top-2 right-2 bg-white p-1 rounded-md shadow hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500",
                title: "View in full screen"
              }, _cache[24] || (_cache[24] = [
                _createElementVNode("svg", {
                  class: "h-5 w-5 text-gray-500",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"
                  })
                ], -1)
              ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-gray-700 text-sm font-bold mb-2" }, " Text Content ", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.emailDraft.textContent) = $event)),
              class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-32",
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.emailDraft.textContent]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[27] || (_cache[27] = _createElementVNode("label", {
              class: "block text-gray-700 text-sm font-bold mb-2",
              for: "draft-recipient"
            }, " Recipient Email ", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "draft-recipient",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.emailDraftRecipient) = $event)),
              type: "email",
              placeholder: "Enter recipient email address",
              class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            }, null, 512), [
              [_vModelText, _ctx.emailDraftRecipient]
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[28] || (_cache[28] = _createElementVNode("label", {
              class: "block text-gray-700 text-sm font-bold mb-2",
              for: "draft-cc"
            }, " CC Email ", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "draft-cc",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.emailDraftCC) = $event)),
              type: "email",
              placeholder: "Enter CC email addresses (comma separated)",
              class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            }, null, 512), [
              [_vModelText, _ctx.emailDraftCC]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearEmailDraft && _ctx.clearEmailDraft(...args))),
              class: "bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            }, " Clear "),
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveEmailDraft && _ctx.saveEmailDraft(...args))),
              class: "bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            }, " Save Draft "),
            _createElementVNode("button", {
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.sendEmailDraft && _ctx.sendEmailDraft(...args))),
              disabled: !_ctx.emailDraft || !_ctx.emailDraftRecipient || _ctx.isEmailDraftSending,
              class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50"
            }, [
              (_ctx.isEmailDraftSending)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Sending..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_25, "Send Draft"))
            ], 8, _hoisted_23)
          ]),
          (_ctx.emailDraftStatus.message)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(['mt-4 p-4 rounded', _ctx.emailDraftStatus.isError ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'])
              }, _toDisplayString(_ctx.emailDraftStatus.message), 3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_26, [
      _cache[42] || (_cache[42] = _createElementVNode("h3", { class: "text-xl font-bold mb-4" }, "Send Test Email (Delete Later)", -1)),
      _createElementVNode("div", _hoisted_27, [
        _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-gray-700 text-sm font-bold mb-2" }, " Recipient Mode ", -1)),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("label", _hoisted_29, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.recipientMode) = $event)),
              value: "single",
              class: "form-radio h-4 w-4 text-blue-600"
            }, null, 512), [
              [_vModelRadio, _ctx.recipientMode]
            ]),
            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "ml-2" }, "Single Recipient (to)", -1))
          ]),
          _createElementVNode("label", _hoisted_30, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.recipientMode) = $event)),
              value: "multiple",
              class: "form-radio h-4 w-4 text-blue-600"
            }, null, 512), [
              [_vModelRadio, _ctx.recipientMode]
            ]),
            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "ml-2" }, "Multiple Recipients (bcc)", -1))
          ])
        ])
      ]),
      (_ctx.recipientMode === 'single')
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _cache[33] || (_cache[33] = _createElementVNode("label", {
              class: "block text-gray-700 text-sm font-bold mb-2",
              for: "test-email"
            }, " Recipient Email ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "test-email",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.testEmailRecipient) = $event)),
              placeholder: "Enter recipient email address",
              class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            }, null, 512), [
              [_vModelText, _ctx.testEmailRecipient]
            ]),
            _cache[34] || (_cache[34] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500" }, "The recipient will see they are the direct recipient of this email.", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.recipientMode === 'multiple')
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            _cache[35] || (_cache[35] = _createElementVNode("label", {
              class: "block text-gray-700 text-sm font-bold mb-2",
              for: "test-email-bcc"
            }, " Recipients Emails ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "test-email-bcc",
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.testEmailBcc) = $event)),
              placeholder: "Enter recipients comma-separated email addresses",
              class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            }, null, 512), [
              [_vModelText, _ctx.testEmailBcc]
            ]),
            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500" }, "Recipients won't see each other's addresses. Format: email1@example.com,email2@example.com", -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_33, [
        _cache[37] || (_cache[37] = _createElementVNode("label", {
          class: "block text-gray-700 text-sm font-bold mb-2",
          for: "test-email-body"
        }, " Email Body ", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "test-email-body",
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.testEmailBody) = $event)),
          placeholder: "Enter email content",
          rows: "4",
          class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        }, null, 512), [
          [_vModelText, _ctx.testEmailBody]
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _cache[41] || (_cache[41] = _createElementVNode("label", {
          class: "block text-gray-700 text-sm font-bold mb-2",
          for: "test-email-attachment"
        }, " Attachments ", -1)),
        _createElementVNode("input", {
          type: "file",
          id: "test-email-attachment",
          accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png",
          onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleTestAttachmentUpload && _ctx.handleTestAttachmentUpload(...args))),
          class: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        }, null, 32),
        (_ctx.testAttachments.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _cache[40] || (_cache[40] = _createElementVNode("h4", { class: "font-medium text-sm mb-2" }, "Attached Files:", -1)),
              _createElementVNode("ul", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testAttachments, (file, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "flex items-center justify-between bg-gray-50 p-2 rounded border"
                  }, [
                    _createElementVNode("div", _hoisted_37, [
                      _cache[38] || (_cache[38] = _createElementVNode("svg", {
                        class: "h-5 w-5 text-gray-500 mr-2",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(file.name), 1),
                      _createElementVNode("span", _hoisted_39, "(" + _toDisplayString(_ctx.formatFileSize(file.size)) + ")", 1)
                    ]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.removeTestAttachment(index)),
                      class: "text-red-500 hover:text-red-700",
                      title: "Remove attachment"
                    }, _cache[39] || (_cache[39] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        })
                      ], -1)
                    ]), 8, _hoisted_40)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.emailStatus.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(['p-4 rounded mb-4', _ctx.emailStatus.isError ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'])
          }, _toDisplayString(_ctx.emailStatus.message), 3))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.sendTestEmail && _ctx.sendTestEmail(...args))),
        disabled: _ctx.isEmailSending ||
                  (_ctx.recipientMode === 'single' && !_ctx.testEmailRecipient) ||
                  (_ctx.recipientMode === 'multiple' && !_ctx.testEmailBcc) ||
                  !_ctx.testEmailBody.trim(),
        class: "bg-purple-500 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline disabled:opacity-50"
      }, [
        (_ctx.isEmailSending)
          ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Sending..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_43, "Send Test Email"))
      ], 8, _hoisted_41)
    ]),
    _createVNode(_component_ConfirmationModal, {
      isOpen: _ctx.showDeleteModal,
      "onUpdate:isOpen": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showDeleteModal) = $event)),
      title: "Delete Email Draft",
      message: `Are you sure you want to delete the email draft '${_ctx.draftToDeleteSubject}'?`,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      confirmButtonClass: "bg-red-600 hover:bg-red-700 text-white focus:ring-red-500",
      iconType: "warning",
      onConfirm: _ctx.confirmDelete
    }, null, 8, ["isOpen", "message", "onConfirm"]),
    _createVNode(_component_EmailPreviewModal, {
      isOpen: _ctx.showPreviewModal,
      "onUpdate:isOpen": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showPreviewModal) = $event)),
      subject: _ctx.emailDraft?.subject || '',
      htmlContent: _ctx.emailDraft?.htmlContent || '',
      textContent: _ctx.emailDraft?.textContent || ''
    }, null, 8, ["isOpen", "subject", "htmlContent", "textContent"])
  ]))
}